import type {RepositoryNWO} from '@github-ui/current-repository'
import {commitStatusDetailsPath} from '@github-ui/paths'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

import {useCallback, useState} from 'react'

import type {CombinedStatusResult} from '../index'
import {useChecksLiveUpdates} from './use-checks-live-updates'

interface UseCommitChecksStatusDetailsOptions {
  aliveChannel?: string | null
  isDialogOpen?: boolean
}

export function useCommitChecksStatusDetails(
  oid: string,
  repo: RepositoryNWO,
  options?: UseCommitChecksStatusDetailsOptions,
): [CombinedStatusResult | undefined, () => void] {
  const [details, setDetails] = useState<CombinedStatusResult>()

  const fetchStatus = useCallback(
    async (reset: boolean) => {
      if (reset) setDetails(undefined)
      if (!oid) return
      const url = commitStatusDetailsPath(repo, oid)
      const response = await verifiedFetchJSON(url)
      setDetails(await response.json())
    },
    [oid, repo],
  )

  const fetchDetails = useCallback(() => fetchStatus(true), [fetchStatus])
  const backgroundFetch = useCallback(() => fetchStatus(false), [fetchStatus])

  useChecksLiveUpdates({
    refetch: backgroundFetch,
    aliveChannel: options?.aliveChannel,
    isActive: options?.isDialogOpen,
  })

  return [details, fetchDetails]
}
